<template>
  <div>
    <app-modal
      :model-value="true"
      eager
      transition="scroll-y-transition"
      size="xl"
      hide-footer
      class="archives-paywall-dialog"
      @cancel="close"
    >
      <template #title>
        <div class="paywall-modal-header-container">
          <img v-if="$vuetify.display.smAndUp"
               src="@/assets/img/closd_logo.svg"
               width="70"
               alt="Closd Symbol"
          />
          <h2 class="px-6 text-center">
            {{ $t('archives.views.ArchivesPaywallDialog.title') }}
          </h2>
        </div>
      </template>

      <template #body>
        <v-row class="ma-0" align="center">
          <v-col cols="12" sm="8" class="archiving-description overflow-auto">
            <!-- This has one link -->
            <i18n-t keypath="archives.views.ArchivesPaywallDialog.intro" tag="p" class="mb-4" scope="global">
              <template #link>
                <a target=_blank :href="$t('archives.views.ArchivesPaywallDialog.arkhineoUrl')">
                  Arkhineo
                </a>
              </template>
            </i18n-t>

            <ul class="custom-bulletpoint-list">
              <li class="custom-bulletpoint">
                <h3 class="custom-bulletpoint-title">
                  {{ $t('archives.views.ArchivesPaywallDialog.bullet1.title') }}
                </h3>
                <p>{{ $t('archives.views.ArchivesPaywallDialog.bullet1.content') }}</p>
              </li>
              <li class="custom-bulletpoint">
                <h3 class="custom-bulletpoint-title">
                  {{ $t('archives.views.ArchivesPaywallDialog.bullet2.title') }}
                </h3>
                <p>{{ $t('archives.views.ArchivesPaywallDialog.bullet2.content') }}</p>
              </li>
              <li class="custom-bulletpoint">
                <h3 class="custom-bulletpoint-title">
                  {{ $t('archives.views.ArchivesPaywallDialog.bullet3.title') }}
                </h3>
                <p>{{ $t('archives.views.ArchivesPaywallDialog.bullet3.content') }}</p>
              </li>
              <li class="custom-bulletpoint">
                <h3 class="custom-bulletpoint-title">
                  {{ $t('archives.views.ArchivesPaywallDialog.bullet4.title') }}
                </h3>
                <p>{{ $t('archives.views.ArchivesPaywallDialog.bullet4.content') }}</p>
              </li>
              <li class="custom-bulletpoint">
                <h3 class="custom-bulletpoint-title">
                  {{ $t('archives.views.ArchivesPaywallDialog.bullet5.title') }}
                </h3>

                <!-- This has list items -->
                <ul class="my-2 ml-8">
                  <li>{{ $t('archives.views.ArchivesPaywallDialog.bullet5.content.1') }}</li>
                  <li>{{ $t('archives.views.ArchivesPaywallDialog.bullet5.content.2') }}</li>
                  <li>{{ $t('archives.views.ArchivesPaywallDialog.bullet5.content.3') }}</li>
                  <li>{{ $t('archives.views.ArchivesPaywallDialog.bullet5.content.4') }}</li>
                </ul>
              </li>
            </ul>
          </v-col>
          <v-col cols="12" sm="4" class="text-center">
            <img v-if="$vuetify.display.smAndUp"
                 src="@/assets/img/archives/archiving.svg"
                 class="archiving-illustration mb-4"
                 alt="Archiving Illustration"
            />
            <AppButton color="primary" href="https://www.closd.com/contact/" target="_blank">
              {{ $t('archives.views.ArchivesPaywallDialog.contactBtnLabel') }}
            </AppButton>
            <p class="text-text-tertiary mt-2">
              {{ $t('archives.views.ArchivesPaywallDialog.contactPhoneText') }}
            </p>
          </v-col>
        </v-row>
      </template>
    </app-modal>

    <!-- This is not meant to be interactable at all, because of the persistent modal -->
    <div class="archives-preview-container">
      <Archives />
    </div>
  </div>
</template>

<script>
import AppButton from '@/common/buttons/AppButton.vue'

import Archives from './Archives.vue'

export default {
  name: 'ArchivesPaywallDialog',
  components: {
    AppButton,
    Archives,
  },
  methods: {
    close () {
      this.$router.back()
    },
  },
}
</script>

<style lang="scss" scoped>
.archives-preview-container {
  filter: blur(2px);
}

.paywall-modal-header-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.archiving-illustration {
  max-width: 350px;
}

.archiving-description {
  max-height: 500px;
}

.custom-bulletpoint p {
  margin-top: 8px;
  margin-bottom: 8px;
}

.custom-bulletpoint-list {
  list-style: inside;
  ::marker {
    color: rgb(var(--v-theme-primary));
  }
}

.custom-bulletpoint {
  margin-top: 20px;
}

.custom-bulletpoint-title {
  // Otherwise the ::before element might get wrapped badly
  display: inline;
}
</style>
